import API from './Api';
import apiClient from './Axios';

export const getForumPosts = () => API.makeGetRequest('/forum/get-posts');

export const getUserForumPosts = (userId: string) =>
  API.makeGetRequest('/forum/get-user-posts', {
    user_id: userId,
  });

export const getForumPostsServer = async () => {
  try {
    const response = await apiClient.get('/forum/get-posts', {
      headers: {
        Accept: 'application/json',
      },
    });

    return {
      status: response.status,
      ...response.data,
      headers: response.headers,
    };
  } catch (error: any) {
    if (error?.response?.data?.errors) {
      throw new Error(error.response.data.errors);
    }

    if (error?.response?.data?.error) {
      throw new Error(error.response.data.error);
    }

    throw new Error(error?.message || 'Unable to load forum posts.');
  }
};

export const createForumPostRequest = ({
  header,
  text,
}: {
  header: string;
  text: string;
}) =>
  API.makePostRequest('/forum/create-post', {
    header: header.trim(),
    text: text.trim(),
  });

export const createForumCommentRequest = ({
  postId,
  text,
}: {
  postId: string;
  text: string;
}) =>
  API.makePostRequest('/forum/create-comment', {
    post_id: postId,
    text: text.trim(),
  });

export const deleteForumPostRequest = (postId: string) =>
  API.makePostRequest('/forum/delete-post', {
    post_id: postId,
  });

export const deleteForumCommentRequest = (commentId: string) =>
  API.makePostRequest('/forum/delete-comment', {
    comment_id: commentId,
  });
